import { render } from "./TopShippingMethodsChart.vue?vue&type=template&id=2607e2b5&ts=true"
import script from "./TopShippingMethodsChart.vue?vue&type=script&lang=ts"
export * from "./TopShippingMethodsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__